import React  from "react";
import { useParams } from 'react-router-dom';
import ModuleForm from "./components/ModuleForm";

const EditModule = () => {
	const { moduleId } = useParams();

	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		<ModuleForm recordId={moduleId} mode="edit"/>
	      </div>
	    </div>
    );
};

export default EditModule;